import { render, staticRenderFns } from "./FIBSelectOption.vue?vue&type=template&id=bd2685ca&scoped=true&"
import script from "./FIBSelectOption.vue?vue&type=script&lang=js&"
export * from "./FIBSelectOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd2685ca",
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QIcon});
